export const TableTrKey = Symbol("TableTrKey");
//# sourceMappingURL=common.js.map